/* Moonvale bed fan page behaviour. One init per .mv section root (re-runs safely in the theme editor). */
(function () {
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';

    /* Gallery: scroll-snap track + thumbs */
    var track = root.querySelector('[data-track]');
    var thumbs = root.querySelectorAll('[data-thumb]');
    if (track && thumbs.length) {
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () {
          var slide = track.children[+t.dataset.thumb];
          track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: 'smooth' });
        });
      });
      var raf;
      track.addEventListener('scroll', function () {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          var i = Math.round(track.scrollLeft / track.clientWidth);
          thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === i); });
        });
      }, { passive: true });
    }

    /* Variant (bundle) selection */
    var form = root.querySelector('[data-mv-form]');
    var radios = root.querySelectorAll('input[name="id"]');
    var prices = root.querySelectorAll('[data-atc-price]');
    var stickyVariant = root.querySelector('[data-sticky-variant]');
    function selected() { return root.querySelector('input[name="id"]:checked'); }
    /* Afterpay placement: keep its amount in step with the chosen pack */
    function syncAfterpay(r) {
      if (!r || !r.dataset.cents) return;
      var amount = (parseInt(r.dataset.cents, 10) / 100).toFixed(2);
      root.querySelectorAll('[data-afterpay] square-placement').forEach(function (p) {
        if (p.getAttribute('data-amount') !== amount) p.setAttribute('data-amount', amount);
      });
    }
    function sync() {
      var r = selected();
      if (!r) return;
      prices.forEach(function (p) { p.textContent = r.dataset.price; });
      root.querySelectorAll('[data-compare-price]').forEach(function (c) { c.textContent = r.dataset.compare || ''; });
      root.querySelectorAll('[data-sale-tag]').forEach(function (g) { g.textContent = r.dataset.tag || ''; g.hidden = !r.dataset.tag; });
      if (stickyVariant) stickyVariant.textContent = r.dataset.units > 1 ? 'Duo Pack' : 'Single';
      syncAfterpay(r);
      var url = new URL(location.href);
      url.searchParams.set('variant', r.value);
      history.replaceState(null, '', url);
    }
    radios.forEach(function (r) { r.addEventListener('change', sync); });
    var tag = root.querySelector('[data-sale-tag]'), sel = selected();
    if (tag && sel) { tag.textContent = sel.dataset.tag || ''; tag.hidden = !sel.dataset.tag; }
    syncAfterpay(sel);

    var duoBtn = root.querySelector('[data-pick-duo]');
    if (duoBtn) duoBtn.addEventListener('click', function () {
      var duo = root.querySelector('input[name="id"][data-units="2"]:not(:disabled)');
      if (duo) { duo.checked = true; sync(); }
      form.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
    root.querySelectorAll('[data-scroll-buy]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        form.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });

    /* Add to cart — Horizon drawer via Shopify.actions, native post as fallback */
    var errorEl = root.querySelector('[data-error]');
    var busy = false;
    form.addEventListener('submit', function (e) {
      var actions = window.Shopify && window.Shopify.actions;
      if (!actions || !actions.updateCart) return;
      e.preventDefault();
      if (busy) return;
      busy = true;
      root.classList.add('is-adding');
      errorEl.hidden = true;
      var pick = selected();
      var lines = [{ merchandiseId: pick.value, quantity: 1 }];
      if (pick.dataset.gift) lines.push({ merchandiseId: pick.dataset.gift, quantity: 2 });
      actions.updateCart(
        { lines: lines },
        { event: { context: 'product' } }
      ).then(function (res) {
        if (res && res.userErrors && res.userErrors.length) throw new Error(res.userErrors[0].message);
        return actions.openCart();
      }).catch(function (err) {
        errorEl.textContent = (err && err.message) || 'Something went wrong. Please try again.';
        errorEl.hidden = false;
      }).finally(function () {
        busy = false;
        root.classList.remove('is-adding');
      });
    });

    /* Delivery window (business days from today), set in the section settings */
    function addBizDays(d, n) {
      d = new Date(d);
      while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() % 6) n--; }
      return d;
    }
    var deliv = root.querySelector('[data-delivery]');
    if (deliv && window.Intl) {
      var f = new Intl.DateTimeFormat('en-AU', { weekday: 'short', day: 'numeric', month: 'short' });
      var dMin = parseInt(deliv.dataset.min, 10) || 5, dMax = parseInt(deliv.dataset.max, 10) || 9;
      deliv.textContent = 'arrives ' + f.format(addBizDays(new Date(), dMin)) + ' – ' + f.format(addBizDays(new Date(), dMax));
    }

    /* Sticky ATC (mobile): appears as soon as the visitor starts scrolling, hides while the
       main Add to cart button is on screen and at the final CTA */
    var sticky = root.querySelector('[data-sticky]');
    var stickyBtn = root.querySelector('[data-sticky-btn]');
    var atc = root.querySelector('[data-atc]');
    var finalCta = root.querySelector('[data-final]');
    if (sticky && 'IntersectionObserver' in window) {
      var scrolled = false, atcInView = false, atFinal = false, ticking = false;
      function update() {
        var show = scrolled && !atcInView && !atFinal;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        stickyBtn.tabIndex = show ? 0 : -1;
      }
      window.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          ticking = false;
          var s = window.scrollY > 240;
          if (s !== scrolled) { scrolled = s; update(); }
        });
      }, { passive: true });
      new IntersectionObserver(function (en) {
        atcInView = en[0].isIntersecting; update();
      }).observe(atc);
      new IntersectionObserver(function (en) {
        atFinal = en[0].isIntersecting; update();
      }).observe(finalCta);
    }
  }
  function boot() { document.querySelectorAll('.mv[data-section]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
